import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import PageTemplate from '../../../components/template/PageTemplate';
import RecommendTagSaveContainer from '../../../containers/recommend/tag/RecommendTagSaveContainer';
import { recommendTagActions } from '../../../store/modules/recommend/tag';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import {
  RECOMMEND_TAG_ITEM_LIST_FILTER_OPTION_MODEL,
  RECOMMEND_TAG_ITEM_LIST_SORT_OPTION_MODEL,
  RECOMMEND_TAG_SAVE_MODEL,
} from '../../../store/modules/recommend/tag/models';
import { RECOMMEND_TAG_PAGE_NAME } from '../../../constants/service/app/recommendTagConstants';

class RecommendTagCopy extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   *  초기화
   */
  componentWillUnmount() {
    const { setData } = this.props;

    setData({
      path: ['recommendTagSave'],
      value: RECOMMEND_TAG_SAVE_MODEL,
    });
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (recommendTagId) => {
    const { prepareCopyTagReview } = this.props;

    prepareCopyTagReview({
      recommendTagId,
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_TAG_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션
       */
      sortOption: RECOMMEND_TAG_ITEM_LIST_SORT_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  render() {
    return (
      <PageTemplate pageName={RECOMMEND_TAG_PAGE_NAME.RECOMMEND_TAG_COPY}>
        <RecommendTagSaveContainer typeDisabled={true} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: recommendTagActions.setData,
  prepareCopyTagReview: recommendTagActions.prepareCopyTagReview,
};

export default connect(null, mapDispatchToProps)(withRouter(RecommendTagCopy));
